import type { SlotValue } from './useWeighing';

/**
 * If tare outweighs bruto, swap the whole slot — weight AND time together —
 * so a slot's timestamp always travels with its own weight. Shared by the
 * scale-driven weigh flow (applyWeight) and manual entry
 * (setManualWeights): both build a candidate {tare, bruto} pair after
 * applying an incoming weight, then run it through here before committing.
 */
export const swapSlotsIfNeeded = (
	tare: SlotValue,
	bruto: SlotValue,
): { tare: SlotValue; bruto: SlotValue } => {
	if (
		tare.weight != null &&
		bruto.weight != null &&
		tare.weight > bruto.weight
	) {
		return { tare: bruto, bruto: tare };
	}
	return { tare, bruto };
};
